var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBreaker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 61,
    viewBox: "0 0 198 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1375 0L51.7191 0.885717L74.4154 13.5956L97.1117 0.885717L98.6934 0L100.275 0.885717L122.971 13.5956L145.668 0.885717L147.249 0L148.831 0.885717L171.527 13.5956L194.223 0.885717L197.387 6.53442L173.109 20.1301L171.527 21.0158L169.946 20.1301L147.249 7.42014L124.553 20.1301L122.971 21.0158L121.39 20.1301L98.6934 7.42014L75.9971 20.1301L74.4154 21.0158L72.8338 20.1301L50.1375 7.42014L27.4412 20.1301L25.8596 21.0158L24.2779 20.1301L0 6.53442L3.16328 0.885717L25.8596 13.5956L48.5559 0.885717L50.1375 0ZM50.1375 39.4921L51.7191 40.3778L74.4154 53.0877L97.1117 40.3778L98.6934 39.4921L100.275 40.3778L122.971 53.0877L145.668 40.3778L147.249 39.4921L148.831 40.3778L171.527 53.0877L194.223 40.3778L197.387 46.0265L173.109 59.6222L171.527 60.5079L169.946 59.6222L147.249 46.9122L124.553 59.6222L122.971 60.5079L121.39 59.6222L98.6934 46.9122L75.9971 59.6222L74.4154 60.5079L72.8338 59.6222L50.1375 46.9122L27.4412 59.6222L25.8596 60.5079L24.2779 59.6222L0 46.0265L3.16328 40.3778L25.8596 53.0877L48.5559 40.3778L50.1375 39.4921Z",
    fill: "#E64E53"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreaker);
export default __webpack_public_path__ + "static/media/breaker.4e17ca6b.svg";
export { ForwardRef as ReactComponent };